<template>
  <!---通过搜索列表页面（组件）-->
  <div>
    <search-header :col="col" :buttonCol="buttonCol">
      <search-list>
        <div v-for="(item,index) in getAvailableQueryItems()" :key="index">
          <a-form-item :label='item.name' v-bind="searchItemLayout">
            <a-input
              v-if="item.type==='input'"
              :allowClear="true"
              style='width: 100%'
              :placeholder='item.placeholder?item.placeholder:"请输入"'
              v-model='queryPageParams[item.keys[0]]'></a-input>
            <a-time-picker
              v-else-if="item.type==='time'"
              :allowClear="true"
              style='width: 100%'
              :format="item.format?item.format:'HH:mm:ss'"
              @change='(value,str)=>onTimeChangeEvent(value, str,item)'
            ></a-time-picker>
            <a-date-picker
              v-else-if="item.type==='date'"
              :allowClear="true"
              style='width: 100%'
              :format="item.format?item.format:'YYYY-MM-DD'"
              @change='(value,str)=>onDateChangeEvent(value, str,item)'
            ></a-date-picker>
            <a-range-picker
              v-else-if="item.type==='range'"
              :allowClear="true"
              style='width: 100%'
              :format="item.format?item.format:'YYYY-MM-DD'"
              @change='(values,strArr)=>onRangeDateChangeEvent(values, strArr,item)'></a-range-picker>
            <a-select
              v-else-if="item.type==='select'"
              :allowClear="true"
              v-model='queryPageParams[item.keys[0]]'
              style='width: 100%'
              :placeholder='item.placeholder?item.placeholder:"请选择"'
              :options="item.selectOptions&&item.selectOptions.length>0?item.selectOptions:[]"
            >
            </a-select>
            <slot v-else :name="item.slot"></slot>
          </a-form-item>
        </div>
        <a-form-item v-if="enableSearch" :style="{'padding-left': leftSpace +'px'}">
          <search-combination-button
            :show-advanced="showAdvanced && queryItemList.length>col-1"
            :unfoldState="advancedState"
            :menuList="menuList"
            :exportType="exportType"
            :size="buttonSize"
            @search="searchEvent"
            :showResetButton="showResetButton"
            @reset="resetEvent"
            @export="exportEvent"
            @change="advancedChange"
          >
            <slot v-for="(item,index) in buttonItems" :name="item" :index="index"></slot>
          </search-combination-button>
        </a-form-item>
      </search-list>
    </search-header>
    <slot :name="operation"></slot>
    <custom-page-table
      ref="table"
      :size="tableSize"
      :rowKey="rowKey"
      :columns="columns"
      :load-data="loadData"
      :queryParams="queryPageParams"
      :request-promise="requestPromise"
      :rowSelection="rowSelection"
      :request-type="requestType"
      :query-path="queryPath"
      :params-path="paramsPath"
      :base-key="baseKey"
      :page-size="pageSize"
      :alert="alert"
      :showResetButton="showResetButton"
      :extraPaginationName="extraPaginationName"
      :customPagination="customPagination"
    >
      <!-- 动态修改表头内容时columns对应列里面不能加title属性，否则不生效 -->
      <!-- slots: { title: 'ticketId' }-->
      <template v-for="(item, i) in headerRenders" :slot="item">
        <slot :name="item"></slot>
      </template>
      <template v-for="(item, i) in customRenders" :slot="item" slot-scope="rowItem">
        <slot :name="item" :text="rowItem.text" :record="rowItem.record" :index="rowItem.index"></slot>
      </template>
      <template :slot="extraPaginationName">
        <slot :name="extraPaginationName"></slot>
      </template>
    </custom-page-table>
  </div>
</template>
<script>
import SearchHeader from '../SearchHeader'
import SearchCombinationButton from '../SearchCombinationButton'
import CustomPageTable from '../CustomPageTable/CustomPageTable'
import searchFormMixins from '@/utils/mixins/searchFormMixins'

const SearchList = SearchHeader.SearchList
export default {
  name: 'SearchPageView',
  components: {
    SearchHeader,
    SearchList,
    SearchCombinationButton,
    CustomPageTable
  },
  mixins: [searchFormMixins],
  props: {
    leftSpace: {
      type: Number,
      default: 0
    },
    buttonItems: {
      type: Array,
      default: function() {
        return []
      }
    },
    alert: {
      type: [Object, Boolean],
      default: null
    },
    col: {
      type: Number,
      default: 4
    },
    pageSize: {
      type: Number,
      default: 10
    },
    buttonCol: {
      type: Number,
      default: 0
    },
    rowKey: {
      type: String,
      default: ''
    },
    requestType: {
      type: String,
      default: 'post'
    },
    //查询式请求路径
    queryPath: {
      type: String,
      default: ''
    },
    //参数式请求路径
    paramsPath: {
      type: String,
      default: ''
    },
    //请求基础模块
    baseKey: {
      type: String,
      default: ''
    },
    columns: {
      type: Array,
      default: function() {
        return []
      }
    },
    tableSize: {
      type: String,
      default: 'default'
    },
    buttonSize: {
      type: String,
      default: 'default'
    },
    showAdvanced: {
      type: Boolean,
      default: false
    },
    showResetButton: {
      type: Boolean,
      default: false
    },
    rowSelection: {
      type: Object,
      default: null
    },
    operation: {
      type: String,
      default: 'operation'
    },
    //导出类型  1、是菜单类型  2是按钮类型
    exportType: {
      type: Number,
      default: 0
    },
    enableSearch: {
      type: Boolean,
      default: true
    },
    //（导出）菜单列表
    menuList: {
      type: Array,
      default: () => ['CSV', 'Excel']
    },
    //菜单数据关键字（当列表数据不是字符串或者数字时，才传）
    itemKey: {
      type: String,
      default: ''
    },
    //查询参数
    queryParams: {
      type: Object,
      default: function() {
        return {}
      }
    },
    //请求的
    requestPromise: {
      type: Function,
      default: undefined
    },

    loadData: {
      type: Function,
      default: undefined
    },
    // 自定义分页显示
    customPagination: {
      type: Boolean,
      default: false
    },
    //分页附加信息
    extraPaginationName: {
      type: String,
      default: ''
    },
    beforeSearch: {
      type: Function,
      default: undefined
    },
    //查询数据列表
    queryItemList: {
      type: Array,
      default: function() {
        // {
        //   name:"",//查询字段名称
        //   keys:[],//查询字段
        //   slot:"",对应的插槽
        //   type:"input", input ,输入框  select 选择框 time //选择时间 date-picker选择日期（单个）  range-picker多个日期
        // }
        return []
      }
    }
  },

  data() {
    return {
      customRenders: [],
      headerRenders: [],
      advancedState: true,
      queryPageParams: {}
    }
  },
  created() {
    this.queryPageParams = { ...this.queryParams }
  },
  watch: {
    'queryParams': function(newVal, oldVal) {
      this.queryPageParams = { ...this.queryPageParams, ...newVal }
    },
    'columns': function(columnsList) {
      this.customRenders = this.getCustomRendersList(columnsList)
      this.headerRenders = this.getHeaderRendersList(columnsList)
    }
  },
  mounted() {
    this.getLogUtils().logWithTag('showResetButton', this.showResetButton)
    this.customRenders = this.getCustomRendersList(this.columns)
    this.headerRenders = this.getHeaderRendersList(this.columns)
  },
  methods: {
    searchEvent(res) {
      if (this.beforeSearch) {
        this.beforeSearch()
      }
      this.$refs.table.refresh(true)
    },
    onRangeDateChangeEvent(values, strArr, item) {
      this.queryPageParams[item.keys[0]] = strArr[0]
      this.queryPageParams[item.keys[1]] = strArr[1]
    },
    onDateChangeEvent(value, str, item) {
      this.queryPageParams[item.keys[0]] = str
    },
    onTimeChangeEvent(value, str, item) {
      this.queryPageParams[item.keys[0]] = str
    },
    getCustomRendersList(columnsList) {
      const customList = []
      if (columnsList && columnsList.length > 0) {
        columnsList.forEach((item, index, arr) => {
          // scopedSlots: { customRender: 'state' }
          if (item && item.scopedSlots && item.scopedSlots.customRender) {
            customList.push(item.scopedSlots.customRender)
          }
        })
      }
      return customList
    },
    getHeaderRendersList(columnsList) {
      const customList = []
      if (columnsList && columnsList.length > 0) {
        columnsList.forEach((item, index, arr) => {
          // scopedSlots: { customRender: 'state' }
          if (item && item.slots && item.slots.title) {
            customList.push(item.slots.title)
          }
        })
      }
      return customList
    },
    refresh(bool = false) {
      this.$refs.table.refresh(bool)
    },
    advancedChange(state) {
      this.advancedState = state
    },
    resetEvent() {
      this.queryPageParams = {}
      this.$emit('reset')
    },
    exportEvent() {
      this.$emit('export')
    },
    getShowList(list) {
      const count = this.col - 1
      if (list && list.length > count) {
        return list.slice(0, count)
      }
      return []
    },
    // getAdvancedList(list) {
    //   const count = this.col - 1
    //   if (list && list.length > count) {
    //     return list.slice(count, list.length)
    //   }
    //   return []
    // },
    getAvailableQueryItems() {
      if (this.advancedState || this.queryItemList.length < this.col) {
        return this.queryItemList
      }
      return this.getShowList(this.queryItemList)
    }
  }
}
</script>
<style scoped>
</style>